<template>
  <v-switch v-model="role" :label="label" @change="update"></v-switch>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'user-business-role',
  props: ['user', 'business'],
  data: () => ({
    role: false
  }),
  computed: {
    ...mapGetters(['SelectedAccount']),
    label: function() {
      return _.isUndefined(this.business.type) ? '' : this.business.name + ' - ' + _.startCase(this.business.type.name);
    }
  },
  methods: {
    ...mapActions(['updateUserBusinessRole']),
    update: function(value) {
      this.updateUserBusinessRole({
        id: this.user.id,
        updates: {
          business_id: this.business.id,
          attach: value
        }
      });
    }
  },
  watch: {
    user: function() {
      this.role = _.includes(this.user.businesses, this.business.id);
    }
  },
  mounted() {
    this.role = _.includes(this.user.businesses, this.business.id);
  }
};
</script>

<style scoped></style>
